export default __webpack_public_path__ + "static/accelerate-f1d1667755f6cf1079513a1277e0b653.webp";